import { createTheme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { shape } from './shape';
import { componentOverrides } from './components';

const SHARED = {
  typography,
  shape,
  spacing: 8,
  components: componentOverrides,
  transitions: { duration: { short: 150, standard: 250, complex: 375 } },
  shadows: [
    'none',
    '0 1px 3px rgba(20,22,31,0.08)',
    '0 4px 12px rgba(20,22,31,0.10)',
    '0 8px 24px rgba(20,22,31,0.12)',
    '0 16px 40px rgba(20,22,31,0.14)',
    ...Array(20).fill('none'),
  ],
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
};

// The one place a MUI theme gets built — call with 'light' or 'dark'.
// See context/ThemeModeContext.js for the toggle that picks which one
// is actually rendered.
export function createAppTheme(mode = 'light') {
  return createTheme({ ...SHARED, palette: mode === 'dark' ? darkPalette : lightPalette });
}

// Back-compat: a static light theme for any code that isn't mode-aware yet.
export const theme = createAppTheme('light');

export { palette, lightPalette, darkPalette } from './palette';
export { radius } from './shape';

export const SIDEBAR_WIDTH = 184;
export const SIDEBAR_COLLAPSED_WIDTH = 56;
export const TOPBAR_HEIGHT = 48;
